export const topSellingRangesItemIds = [
  '329011820',
  '206943135',
  '327655800',
  '329371842',
  '315616391',
  '321998664',
  '322488448',
  '327516324',
  '315616497',
  '315493076'
];

export const topSellingRangesAnchorId = topSellingRangesItemIds.join(',');

export const topSellingRangesTitle = 'Top 10 Best-Selling Ranges';

export const topSellingRangesSchemaName = 'pip_alternatives';
